// extracted by mini-css-extract-plugin
export default {"screen":"MainScreen_screen__AF+tw","btn":"MainScreen_btn__YPiVq","icon":"MainScreen_icon__lkyEE"};